export const blogData = [
    // {
    //     id: 3,
    //     title: '-',
    //     description: '-',
    //     date: '-',
    //     image: 'https://1.bp.blogspot.com/-GR19yCNbKCE/XuRcKEfKvhI/AAAAAAAAAwY/srFWw5pOpzMibeJb__SmgZpx9dIpNNWqgCK4BGAsYHg/w640-h426/anonymous1.jpg',
    //     url: '-'
    // },
    {
        id: 2,
        title: 'MyGlamm',
        description: 'MyGlamm is a direct-to-consumer beauty brand that offers an online beauty products marketplace with international spa and salon products',
        date: '19 Dec 2021',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzfPILAB0GbFEKv6n8OPN-vUiXg0xM59C7Ag&usqp=CAU',
        url: 'https://medium.com/@shubhamsri0807/clone-of-myglamm-com-unit-4-construct-week-project-for-shopping-cosmetics-136bf5942f64'
    },
    {
        id: 1,
        title: 'plumgoodness',
        description: 'Skin care should be a joyful, nice treat for your skin to restore and maintain your skin at its natural best.',
        date: 'Oct 23, 2021',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5CghWOOYT1zgsgecSHhcFwnnVciWn6jFS2Q&usqp=CAU',
        url: 'https://medium.com/@shubhamsri0807/cloning-plum-com-a-little-functional-and-more-visual-clone-773dd525da0b'
    },
    // {
    //     id: 4,
    //     title: '-',
    //     description: '-',
    //     date: '-',
    //     image: 'https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png',
    //     url: '-'
    // },
    // {
    //     id: 5,
    //     title: '-',
    //     description: '-',
    //     date: '-',
    //     image: 'https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg',
    //     url: '-'
    // },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/